export interface ActionsMenuPosition {
  top: number;
  right: number;
  anchorTop: number;
}

/**
 * Calcula a posição do dropdown em relação à janela, permitindo que ele escape
 * de wrappers com rolagem horizontal, como o usado pelas tabelas das listas.
 */
export function getActionsMenuPosition(event: Event): ActionsMenuPosition | null {
  const target = event.currentTarget;
  if (!(target instanceof HTMLElement)) {
    return null;
  }

  const rect = target.getBoundingClientRect();
  return {
    top: rect.bottom + 4,
    right: window.innerWidth - rect.right,
    anchorTop: rect.top,
  };
}

/**
 * Move o menu para cima quando a posição inicial não cabe na área visível.
 * O menu já precisa estar renderizado para que sua altura possa ser medida.
 */
export function adjustActionsMenuPosition(
  position: ActionsMenuPosition | null,
): ActionsMenuPosition | null {
  if (!position || typeof document === 'undefined' || typeof window === 'undefined') {
    return position;
  }

  const dropdown = document.querySelector<HTMLElement>('.actions-menu-dropdown--fixed');
  if (!dropdown) {
    return position;
  }

  const viewportPadding = 8;
  const rect = dropdown.getBoundingClientRect();
  if (rect.bottom <= window.innerHeight - viewportPadding) {
    return position;
  }

  return {
    ...position,
    top: Math.max(viewportPadding, position.anchorTop - rect.height - 4),
  };
}
